// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @ components
const { MortgageRequestSimpleNoteUploaded } = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteUploaded/mortgageRequestSimpleNoteUploaded');

const MortgageRequestSimpleNoteUploadedView = props => {
    const { immGlobalPosition } = props;
    const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
    const mappingBreadcrumb = [
        {
            text: formatText('navbar-loans'),
            url: '/myprofile/loans-mortgages'
        },
        {
            text: formatText('mortgageRequestPresentation-title'),
            url: '/myprofile/mortgage/panel'
        },
        {
            text: formatText('mortgageRequestSimpleNoteUploaded-title'),
            url: ''
        }
    ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

    return (
        <div className="mortgage-request-simple-note-uploaded-view">
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('mortgageRequestSimpleNoteUploaded-title')}
                        />
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="col-xs-offset-2 col-xs-8">
                            <MortgageRequestSimpleNoteUploaded />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

MortgageRequestSimpleNoteUploadedView.propTypes = {
    immGlobalPosition: PropTypes.object.isRequired,
}

module.exports.MortgageRequestSimpleNoteUploadedView = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgageRequestSimpleNoteUploadedView);
